import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountDisclaimerCheckboxClasses,
} from '@dxp-module/themes'

const disclaimerCheckboxStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountDisclaimerCheckboxClasses
>(
  () => ({
    root: {
      margin: '15px 0 0 0',
    },
    item: {},
    itemChecked: {},
    itemDisabled: {},
    itemRoot: {},
    checkboxGroup: {
      display: 'flex',
      flexDirection: 'column',
    },
    row: {},
    label: {
      display: 'none',
    },
  }),
  { name: 'MyAccount_DisclaimerCheckbox' }
)

export default disclaimerCheckboxStyles
